import { DateTime } from 'luxon';

/**
 * Finds the first item whose `date` falls on the given day.
 */
export function findByDate<T extends { date: string }>(
  items: T[],
  day: DateTime,
): T | undefined {
  return items.find(item => day.equals(DateTime.fromISO(item.date).startOf('day')));
}
